// removed by extract-text-webpack-plugin
module.exports = {"sm-breakpoint":"576px","md-breakpoint":"768px","lg-breakpoint":"992px","xl-breakpoint":"1200px","primary-color":"#0d318e","secondary-color":"#f74a53","text-color":"#59667f","heading-color":"#1b263c","accent-color":"#0396ff","menu-text-color":"#15346c","dark-gray-color":"#1b263c","medium-gray-color":"#59667f","light-gray-color":"#eff0f8","border-color":"#e5e6f1","section-background-color":"#f5f6fa","section-background-grey":"#f2f3fa","shadow-color":"#112174","container":"_1VKnWu8veWESMoVHX_hxSw","input":"_1LJXz-tPbEXnTkoB6IUTiz","button":"_3fSulHZlQySbN7RIT-CAiu"};


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/NetworksPage/Search/Search.scss
// module id = 839
// module chunks = 0